import * as React from "react"
import { Button, Spinner, ButtonProps } from "react-bootstrap"

interface ActionButtonProps extends ButtonProps {
  spin?: boolean
  disableOnSpin?: boolean
  children?: React.ReactNode
}

export default class ActionButton extends React.PureComponent<ActionButtonProps> {
  render() {
    const { spin, disableOnSpin, disabled, className, children, ...buttonProps } = this.props
    const actualDisabled = disabled || (disableOnSpin && spin)
    const actualClassName = `${className || ""} btn-icon`
    return (
      <Button {...buttonProps} className={actualClassName} disabled={actualDisabled}>
        {children}
        {spin && <Spinner animation="border" size="sm" variant={this.props.variant} className="ml-1" />}
      </Button>)
  }
}
